// project import
import dashboard from './dashboard';
import templates from './templates';
import admin from './admin';
import data from './data';
import circuito from './circuito';
import administradorCircuito from './administrador-circuito';
import kanban from './kanban';
import tasksBoard from './tasks-board';
// import usuarios from './usuarios';


// ==============================|| MENU ITEMS ||============================== //

const menuItems = {
  items: [
    dashboard,
    templates,
    admin,
    data,
    administradorCircuito,
    circuito,
    kanban,
    tasksBoard,
  // usuarios,
  ]
};

export default menuItems;

